.header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 20px;
  min-height: var(--cl-control-height);
  margin-bottom: 20px;
}

.title {
  margin: 0;
  min-width: 0;
  line-height: var(--cl-lh-base);
}

.page .title {
  color: var(--cl-text);
  font-size: var(--cl-fs-lg);
  font-weight: var(--cl-fw-medium);
}

.profile .title {
  color: var(--cl-modal-title);
  font-size: var(--cl-fs-2xl);
  font-weight: var(--cl-fw-regular);
}

.middle {
  flex: 1;
  min-width: 0;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
